import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/SurfacesTable.vue"),
          meta: { title: "Список поверхностей", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/SurfacesForm.vue"),
          meta: { title: "Создать поверхность", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/SurfacesForm.vue"),
          meta: { title: "Редактировать поверхность", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
